import * as React from "react";
import Card from 'react-bootstrap/Card';

export default class extends React.Component {
  render() {
    return <>
      <Card className="mb-4">
        <Card.Header>
          Prices
        </Card.Header>
        <Card.Body>
          <Card.Text>
            XXX
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  }
}